const src = import.meta.ROLLUP_FILE_URL_fN3GBDImFL4syCUWbqabiA;
export default {
  src,
  srcSet: src + " " + 2247 + "w",
  width: 2247,
  height: 1053,
};